import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { saveDownloadedFile, SPREADSHEET_MIME_TYPE } from '../downloadFile';

interface TransitProps {
  id: string;
  name: string;
}

export const useDownloadAllHouseConsignmentItems = () => {
  return useMutation({
    mutationFn: async ({ id, name }: TransitProps) => {
      const result = await apiClient.transit.downloadAllHouseConsignmentItems.query({ params: { id } });
      if (result.status !== 200) throw result.body;

      saveDownloadedFile(result.body as Blob, result.headers, SPREADSHEET_MIME_TYPE, `${name}-all-houseConsignment-items.xlsx`);
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the list!');
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the house consignment items!`);
    },
  });
};
